<template>
  <div>
    <b-modal
        v-model="modalVisible"
        id="modal-login"
        centered
        ref="ItensModal"
        title="Itens"
        @hidden="resetModal"
        ok-only
        size="xl"
    >
      <b-form>
        <b-card>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="sequencia">SEQUÊNCIA</label>
                <b-form-input
                    id="sequencia"
                    type="text"
                    placeholder="Sequencia"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].sequenciaItem"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="quantidade">QUANTIDADE</label>
                <b-form-input
                    id="quantidade"
                    type="text"
                    placeholder="quantidade"
                    :value="formatarNumeroInteiro($store.getters['PTC_PedidosClient/getItens'].qtdItem)"
                    disabled
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="item">ITEM</label>
                <b-form-input
                    id="item"
                    type="text"
                    placeholder="Item"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].codItem"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="descricao">Descrição</label>
                <b-form-input
                    id="descricao"
                    type="text"
                    placeholder="Descrição"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].descrItem"
                    disabled
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ordem-compra">ORDEM COMPRA</label>
                <b-form-input
                    id="ordem-compra"
                    type="text"
                    placeholder="ordem-compra"
                    disabled
                />
              </b-form-group>
            </b-col>
          </b-row> -->
        </b-card>
        <b-card title="Preço">
          <b-row cols="12">
            <b-col md="4">
              <b-form-group>
                <label for="desconto">DESCONTO %</label>
                <b-form-input
                    id="desconto"
                    type="text"
                    placeholder="desconto"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrDesconto"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="preco">PREÇO VENDA</label>
                <b-form-input
                    id="preco"
                    type="text"
                    placeholder="preço"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrUnitario"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="total">TOTAL</label>
                <b-form-input
                    id="total"
                    type="text"
                    placeholder="total"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrTotalItem"
                    disabled
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card title="Impostos">
          <b-row cols="12">
            <b-col md="4">
              <b-form-group>
                <label for="baseIcms">BASE ICMS</label>
                <b-form-input
                    id="baseIcms"
                    type="text"
                    placeholder="base icms"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrBaseCalcICMS"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="aliquotaIcms">ALÍQUOTA ICMS</label>
                <b-form-input
                    id="aliquotaIcms"
                    type="text"
                    placeholder="aliquota icms"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].percICMS"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="valorIcms">VALOR ICMS</label>
                <b-form-input
                    id="valorIcms"
                    type="text"
                    placeholder="valor icms"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrICMS"
                    disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="basePis">BASE PIS</label>
                <b-form-input
                    id="basePis"
                    type="text"
                    placeholder="base pis"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrBaseCalcPIS"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="aliquotaPis">ALÍQUOTA PIS</label>
                <b-form-input
                    id="aliquotaPis"
                    type="text"
                    placeholder="aliquota pis"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].percPIS"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="valorPis">VALOR PIS</label>
                <b-form-input
                    id="valorPis"
                    type="text"
                    placeholder="valor pis"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrPIS"
                    disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="baseCofins">BASE COFINS</label>
                <b-form-input
                    id="baseCofins"
                    type="text"
                    placeholder="base cofins"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrBaseCalcCOFINS"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="aliquotaCofins">ALÍQUOTA COFINS</label>
                <b-form-input
                    id="aliquotaCofins"
                    type="text"
                    placeholder="aliquota cofins"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].percCOFINS"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="valorCofins">VALOR COFINS</label>
                <b-form-input
                    id="valorCofins"
                    type="text"
                    placeholder="valor cofins"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrCOFINS"
                    disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="baseIpi">BASE IPI</label>
                <b-form-input
                    id="baseIpi"
                    type="text"
                    placeholder="base ipi"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrBaseCalcIPI"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="aliquotaIpi">ALÍQUOTA IPI</label>
                <b-form-input
                    id="aliquotaIpi"
                    type="text"
                    placeholder="aliquota ipi"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].percIPI"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="valorIpi">VALOR IPI</label>
                <b-form-input
                    id="valorIpi"
                    type="text"
                    placeholder="valor ipi"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrIPI"
                    disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="baseSt">BASE ST</label>
                <b-form-input
                    id="baseSt"
                    type="text"
                    placeholder="base st"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrBaseST"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="aliquotaSt">ALÍQUOTA ST</label>
                <b-form-input
                    id="aliquotaSt"
                    type="text"
                    placeholder="aliquota st"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].percST"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="valorSt">VALOR ST</label>
                <b-form-input
                    id="valorSt"
                    type="text"
                    placeholder="valor st"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrST"
                    disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="baseIva">BASE IVA</label>
                <b-form-input
                    id="baseIva"
                    type="text"
                    placeholder="base iva"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrBaseIVA"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="aliquotaIva">ALÍQUOTA IVA</label>
                <b-form-input
                    id="aliquotaIva"
                    type="text"
                    placeholder="aliquota iva"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].percIVA"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="valorIva">VALOR IVA</label>
                <b-form-input
                    id="valorIva"
                    type="text"
                    placeholder="valor iva"
                    v-model="$store.getters['PTC_PedidosClient/getItens'].vlrIVA"
                    disabled
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
import store from '@/store';

export default {
  components: {
    BFormSelect,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      modalVisible: false,
      type: '',
      contato: {
        clientecontatoseq: '',
        clientearea: '',
        clientecontatonome: '',
        clientecontatoseqerp: '',
        clientecontatoemail: '',
        clientecontatotelefone: '',
        clientecontatoramal: '',
        clientecontatocelular: '',
        clientecontatoprincipal: '',
        clientecontatoobservacoes: '',
      },
    };
  },
  methods: {
    formatarNumeroInteiro(valor) {
      if (!valor && valor !== 0) return '';

      const numero = parseFloat(valor);

      if (Number.isInteger(numero)) {
        return numero.toString();
      }

      return numero.toString();
    },
    abrirModal(item) {
      store.commit('PTC_PedidosClient/SET_ITENS_PEDIDO', item);
      console.log('Abrindo modal com item:', item);
      this.modalVisible = true;
    },
    resetModal() {
      this.endereco = {
        clienteEnderecoseq: 1,
        tipoEnderecoid: 'COBRANCA',
        clienteenderecocep: '',
        clienteendereco: '',
        clienteenderecobairro: '',
        paisid: '',
        clienteendereconumero: '',
        clienteenderecocomplemento: '',
        ufid: '',
        clienteenderecocidade: '',
        clienteenderecoobservacoes: '',
      };
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    async handleSubmit() {
      this.$nextTick(() => {
        this.$refs.ItensModal.hide();
      });
    },
  },
};
</script>
